module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_bundled-923325c9463f9608beee5dc7941090c9.png";